<template> 
  <div>
  <common-header></common-header>
  <div class="solution">
    <div class="banner">
      <div class="content">
        <div class="clearfix bannerlogo">
          <pub-animate>
            <div v-show="showNavPic" style="height:100%">
              <div class="fl">
                <h1 class="ft36">{{lanInfo.banner01.title}}</h1>
                <p>{{lanInfo.banner01.content}}</p>
              </div>
              <div class="fr">
                <img src="../assets/images/solution/banenr_jjfa.png" alt>
              </div>
            </div>
          </pub-animate>
        </div>
      </div>
    </div>
    <div class="contentBox">
      <div class="clearfix content box1">
        <pub-animate enterClass="fadeInLeft" @showAnimate="show">
          <div class="fl" v-show="showPic1_left" style="padding-left: 23px;">
            <img src="../assets/images/solution/jjfa_tu1.png" alt>
          </div>
        </pub-animate>
        <pub-animate enterClass="fadeInRight" @showAnimate="show">
          <div class="fr" v-show="showPic1_right">
            <span class="ft24 title">{{lanInfo.JudicialSolutions.title}}</span>
            <div class="content">
              <p>{{lanInfo.JudicialSolutions.item1}}</p>
              <p>{{lanInfo.JudicialSolutions.item2}}</p>
              <p>{{lanInfo.JudicialSolutions.item3}}</p>
              <p>{{lanInfo.JudicialSolutions.item4}}</p>
              <p>{{lanInfo.JudicialSolutions.item5}}</p>
            </div>
          </div>
        </pub-animate>
      </div>
      <div
        style="width:100%;background: #f9f9f9;padding-bottom: 0px;padding-top: 0px;
    height: 440px;"
      >
        <div class="clearfix content box1" style="background: #f9f9f9;padding-top: 40px;">
          <pub-animate enterClass="fadeInLeft" @showAnimate="showPic2_left=true">
            <div class="fl" v-show="showPic2_left" style="padding-top: 42px;">
              <span class="ft24 title">{{lanInfo.CooperativeSolution.title}}</span>
              <div class="content">
                <p>{{lanInfo.CooperativeSolution.item1}}</p>
                <p>{{lanInfo.CooperativeSolution.item2}}</p>
                <p>{{lanInfo.CooperativeSolution.item3}}</p>
                <p>{{lanInfo.CooperativeSolution.item4}}</p>
              </div>
            </div>
          </pub-animate>
          <pub-animate enterClass="fadeInRight" @showAnimate="showPic2_right=true">
            <div class="fr" v-show="showPic2_right" style="padding-right: 26px;">
              <img src="../assets/images/solution/jjfa_tu2.png" alt>
            </div>
          </pub-animate>
        </div>
      </div>

      <div class="clearfix second box3">
        <div class="content" style="height:100%">
          <pub-animate enterClass="fadeInLeft" @showAnimate="showPic3_left=true">
            <div class="fl" v-show="showPic3_left" style="margin-top:20px;padding-left: 23px;">
              <img src="../assets/images/solution/jjfa_tu3.png" alt>
            </div>
          </pub-animate>
          <pub-animate enterClass="fadeInRight" @showAnimate="showPic3_right=true">
            <div class="fr" v-show="showPic3_right" style="height:372px;padding-top: 77px;">
              <span class="ft24 title">{{lanInfo.AttributionSolution.title}}</span>
              <div class="content">
                <p>{{lanInfo.AttributionSolution.item1}}</p>
                <p>{{lanInfo.AttributionSolution.item2}}</p>
                <p>{{lanInfo.AttributionSolution.item3}}</p>
                <p>{{lanInfo.AttributionSolution.item4}}</p>
              </div>
            </div>
          </pub-animate>
        </div>
      </div>
      <div class="clearfix content box1">
        <pub-animate enterClass="fadeInLeft" @showAnimate="showPic4_left=true">
          <div class="fl" v-show="showPic4_left">
            <span
              class="ft24 title"
              style="padding-top: 42px;"
            >{{lanInfo.DistributedApplication.title}}</span>
            <div class="content">
              <p>{{lanInfo.DistributedApplication.item1}}</p>
              <p>{{lanInfo.DistributedApplication.item2}}</p>
              <p>{{lanInfo.DistributedApplication.item3}}</p>
              <p>{{lanInfo.DistributedApplication.item4}}</p>
            </div>
          </div>
        </pub-animate>
        <pub-animate enterClass="fadeInRight" @showAnimate="showPic4_right=true">
          <div class="fr" v-show="showPic4_right">
            <img src="../assets/images/solution/jjfa_tu4.png" alt>
          </div>
        </pub-animate>
      </div>
    </div>
  </div>
  </div>

</template>

<script>
// 首页
export default {
  data() {
    return {
      showNavPic: false,
      showPic1_left: false,
      showPic1_right: false,
      showPic2_left: false,
      showPic2_right: false,
      showPic3_left: false,
      showPic3_right: false,
      showPic4_left: false,
      showPic4_right: false
    };
  },
  mounted() {
    setTimeout(() => {
      this.showNavPic = true;
    }, 1);
  },
  computed: {
    lanInfo() {
      // console.log(this.$store.getters.getLanInfo);
      return this.$store.getters.getLanInfo.solution;
    },
    lanType() {
      return this.$store.getters.getLanType;
    }
  },
  methods: {
    show() {
      setTimeout(() => {
        this.showPic1_left = true;
        this.showPic1_right = true;
      }, 800);
    }
  }
};
</script>

<style scoped lang="scss">
.solution {
  position: relative;
  z-index: -1;
  .content {
    width: 1200px;
    overflow: hidden;
    margin: 0 auto;
  }
  .banner {
    width: 100%;
    background: #0e285a;
     .ft36{
          font-size: 32px;
        }
    .bannerlogo {
      height: 418px;
      .fl {
        width: 728px;
        padding-top: 171px;
        color: #fff;
        h1{
          font-weight: 400;
        }
        p {
          margin-top: 9px;
          line-height: 38px;
          font-size: 14px;
        }
      }
      .fr {
        width: 472px;
        padding-top: 53px;
      }
    }
  }
  .contentBox {
    padding: 20px 0;
    font-size: 16px;
    & > div {
      padding: 40px 0;
    }
    .title {
      display: inline-block;
      margin-bottom: 40px;
    }
    .content {
      p {
        line-height: 50px;
        font-size: 14px;
      }
      span {
        font-weight: bold;
      }
    }

    .fl {
      width: 699px;
    }
    .fr {
      width: 500px;
    }
    .second {
      background: #0e285a;
      color: #fff;
    }
  }
  .box1 {
    height: 400px;
  }
  .box2 {
    height: 420px;
  }
  .box3 {
    height: 487px;
  }
  .center {
    text-align: center;
  }
  img {
    cursor: pointer;
    transition: all 0.7s ease-in-out 0s;
    &:hover {
      transform: scale(1.1, 1.1);
    }
  }
}
</style>
